/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect, useRef } from "react";
import { Input, Button, Tooltip, Modal, message } from "antd";
import Phone from "../../assests/phone.gif";
import Tune from "../../assests/tune.mp3";
import * as classes from "./Options.module.css";
import { CopyToClipboard } from "react-copy-to-clipboard";
import VideoContext from "../../context/VideoContext";
import Hang from "../../assests/hang.svg";
import {
	UserOutlined,
	CopyOutlined,
	InfoCircleOutlined,
	PhoneOutlined,
} from "@ant-design/icons";
import { socket } from "../../context/VideoState";

//some spacing from ugly import section

const Options = () => {
	const [idToCall, setIdToCall] = useState("");

	const [isModalVisible, setIsModalVisible] = useState(false);
	const Audio = useRef();
	const {
		call,
		callAccepted,
		myVideo,
		userVideo,
		stream,
		name,
		setName,
		callEnded,
		me,
		callUser,
		leaveCall,
		answerCall,
		otherUser,
		setOtherUser,
		leaveCall1,
	} = useContext(VideoContext);

	useEffect(() => {
		if (isModalVisible) {
			Audio?.current?.play();
		} else Audio?.current?.pause();
	}, [isModalVisible]);

	const showModal = (showVal) => {
		setIsModalVisible(showVal);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		leaveCall1();
		window.location.reload();
	};
	useEffect(() => {
		if (call.isReceivingCall && !callAccepted) {
			setIsModalVisible(true);
			setOtherUser(call.from);
		} else setIsModalVisible(false);
	}, [call.isReceivingCall]);

	return (
		<div className={classes.options}>
			<div
				style={{
					marginBottom: "1.5rem",
					border: "2px solid",
					padding: "15px",
					boxShadow: "5px 10px 2px #2c292d",
				}}>
				<strong>Account Name</strong>
				<Input
					size='large'
					placeholder='Your name'
					prefix={<UserOutlined />}
					maxLength={15}
					suffix={<small>{name.length}/15</small>}
					value={name}
					onChange={(e) => {
						setName(e.target.value);
						localStorage.setItem("name", e.target.value);
					}}
					className={classes.inputgroup}
				/>
				<div className={classes.share_options}>
					<CopyToClipboard text={me}>
						<Button
							type='primary'
							style={{
								background: "dodgerblue",
								borderColor: "black",
								color: "#fdf9f3",
								boxShadow: "2px 5px 2px black",
							}}
							icon={<CopyOutlined />}
							className={classes.btn}
							tabIndex='0'
							onClick={() => message.success("Code copied successfully!")}>
							Copy Code
						</Button>
					</CopyToClipboard>
				</div>
			</div>
			<div
				style={{
					marginBottom: "1.5rem",
					border: "2px solid",
					padding: "15px",
					boxShadow: "5px 10px 2px #2c292d",
				}}>
				<strong>Make A Call</strong>

				<Input
					placeholder='Enter code to call'
					size='large'
					className={classes.inputgroup}
					value={idToCall}
					onChange={(e) => setIdToCall(e.target.value)}
					style={{ marginRight: "0.5rem", marginBottom: "0.5rem" }}
					prefix={<UserOutlined className='site-form-item-icon' />}
					suffix={
						<Tooltip title='Enter code of the other user'>
							<InfoCircleOutlined style={{ color: "rgba(0,0,0,.45)" }} />
						</Tooltip>
					}
				/>

				{callAccepted && !callEnded ? (
					<Button
						variant='contained'
						onClick={leaveCall}
						className={classes.hang}
						tabIndex='0'>
						<img src={Hang} alt='hang up' style={{ height: "15px" }} />
						&nbsp; Hang up
					</Button>
				) : (
					<Button
						type='primary'
						style={{
							background: "dodgerblue",
							borderColor: "black",
							color: "fdf9f3",
							boxShadow: "2px 5px 2px black",
							margin: "auto",
						}}
						icon={<PhoneOutlined />}
						onClick={() => {
							if (name.length) callUser(idToCall);
							else message.error("Please enter your name to call!");
						}}
						className={classes.btn}
						tabIndex='0'>
						Call
					</Button>
				)}
			</div>

			{call.isReceivingCall && !callAccepted && (
				<>
					<audio src={Tune} loop ref={Audio} />
					<Modal
						title='Incoming Call'
						visible={isModalVisible}
						onOk={() => showModal(false)}
						onCancel={handleCancel}
						footer={null}>
						<div style={{ display: "flex", justifyContent: "space-around" }}>
							<h1>
								{call.name} is calling you:{" "}
								<img
									src={Phone}
									alt='phone ringing'
									className={classes.phone}
									style={{ display: "inline-block" }}
								/>
							</h1>
						</div>
						<div className={classes.btnDiv}>
							<Button
								variant='contained'
								className={classes.answer}
								color='#29bb89'
								icon={<PhoneOutlined />}
								onClick={() => {
									answerCall();
									Audio.current.pause();
								}}
								tabIndex='0'>
								Answer
							</Button>
							<Button
								variant='contained'
								className={classes.decline}
								icon={<PhoneOutlined />}
								onClick={() => {
									setIsModalVisible(false);
									Audio.current.pause();
								}}
								tabIndex='0'>
								Decline
							</Button>
						</div>
					</Modal>
				</>
			)}
		</div>
	);
};

export default Options;
